/* 🤖 this file was generated by svg-to-ts */
export const svgArrowRight: {
    name: "arrow-right";
    data: string;
} = {
    name: "arrow-right",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__arrow-right" viewBox="0 0 24 24"><path id="ng__path-arrow-right" fill="none" d="M 9,3 18,12 9,21"/></symbol></svg>`,
};
